'use strict';

/* Services */
import settingsService from '../../services/settings/settings.service';

/* Views */
import settingsList from './list/settings-list.component';
import settingsEdit from './edit/settings-edit.component';
import settingsEditGrid from './edit-grid/settings-edit-grid.component';

/* Module */
export default angular.module('conduu.ap.settings', [settingsService, settingsList, settingsEdit, settingsEditGrid])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/settings/index.js